<template>
  <div>
    <v-sheet class="py-4 py-md-6" color="primary">
      <TitleWidget dark>
        {{ title }}
      </TitleWidget>
    </v-sheet>

    <v-container class="pt-0 pt-md-6 pb-10 pb-md-13 pb-lg-16 item">
      <v-row justify="center">
        <v-col cols="12">
          <div
            v-if="item.text"
            class="
              grey--text
              text--darken-2 text-subtitle-1
              font-weight-light
              mt-6
              item-text
              ck-content
            "
          >
            <span class="font-secondary" v-html="item.text"></span>
          </div>
        </v-col>
      </v-row>

      <div v-if="images.length" class="grid-list mt-6">
        <template v-for="({ thumb }, keyImages) in images">
          <img
            :key="keyImages"
            @click="showGallery(keyImages)"
            class="d-block cursor-pointer"
            :src="thumb"
            width="100%"
          />
        </template>
      </div>
    </v-container>
  </div>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";

const _config = {
  mod: "gallery",
};

const _data = {
  title: "Galeria de Fotos",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    images() {
      return (
        this.item?.img?.list.map(({ path }) => ({
          src: this.files + path + "?resize=1&w=1200",
          thumb: this.files + path + "?resize=1&w=400",
        })) || []
      );
    },
  },
  methods: {
    showGallery(index) {
      window.showGalleryWidget(this.images, index);
    },
  },
  created() {
    this.$rest(_config.mod).get({
      save: (state, data) => (state.item = data),
    });
  },
  components: {
    TitleWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-text {
    line-height: 1.6;
  }

  .grid-list {
    display: grid;
    gap: 12px;
    grid-template-columns: repeat(4, 1fr);

    @media screen and (max-width: 959.9px) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media screen and (max-width: 599.9px) {
      grid-template-columns: 1fr 1fr;
    }

    img {
      aspect-ratio: 4 / 3;
      object-fit: cover;
    }
  }
}
</style>
